import i18n from '@/utils/i18n';

const state = {
  scrollY: 0,
  status: 1,
  date: '',
  activeName: '1',
  selfId: 0,
  selfOperate: '',
  selfType: '',
  selfViewLog: '',
  selfViewLogVisible: false,
}

const mutations = {
  changeScrollY(state, scrollY) {
    state.scrollY = scrollY
  },
  changeStatus(state, status) {
    state.status = status
  },
  changeDate(state, date) {
    state.date = date
  },
  changeActiveName(state, name) {
    state.activeName = name
  },
  changeSelfId(state, name) {
    state.selfId = name
  },
  changeSelfOperate(state, name) {
    state.selfOperate = name
  },
  changeViewLog(state, name) {
    state.selfViewLog = name
  },
  changeViewLogVisible(state, name) {
    state.selfViewLogVisible = name
  },
  changeSelfType(state, name) {
    state.selfType = name
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

